import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn';
/**
 * Written out per density rather than assembled, because Tailwind's scanner reads source text and
 * a class built at runtime is never emitted.
 */
const DENSITY_CLASSES = {
    console: {
        base: 'h-8 rounded-pill border px-[13px] font-brand text-[12.5px] font-semibold transition-colors disabled:opacity-50',
        on: 'border-primary bg-primary text-primary-foreground',
        off: 'border-border bg-card text-muted-foreground hover:text-foreground',
    },
    wizard: {
        base: 'rounded-pill border-[1.5px] px-4 py-2 font-brand text-sm font-medium transition-colors disabled:opacity-50',
        on: 'border-primary bg-primary text-primary-foreground',
        off: 'border-border bg-card text-text-body hover:border-border-strong',
    },
    member: {
        base: 'rounded-pill border-[1.5px] px-[15px] py-[9px] font-brand text-sm font-semibold transition-colors disabled:opacity-50',
        on: 'border-primary bg-primary text-primary-foreground',
        off: 'border-border bg-card text-text-body hover:border-border-strong',
    },
};
export function ToggleChip({ checked, onChange, children, disabled = false, density = 'console', selection = 'multi', onRemove, removeLabel, }) {
    const metrics = DENSITY_CLASSES[density];
    const role = selection === 'single' ? 'radio' : 'checkbox';
    if (onRemove === undefined) {
        return (_jsx("button", { type: "button", role: role, "aria-checked": checked, disabled: disabled, onClick: () => onChange(!checked), className: cn(metrics.base, checked ? metrics.on : metrics.off), children: children }));
    }
    // The wrapper carries the pill so the two buttons read as one chip; the toggle keeps the
    // padding so its hit area is the whole label, and the ✕ takes the trailing gap the design
    // system's `Tag` gives it (`gap: 7`, `marginRight: -4`).
    return (_jsxs("span", { className: cn('inline-flex items-center gap-[7px]', metrics.base, checked ? metrics.on : metrics.off), children: [_jsx("button", { type: "button", role: role, "aria-checked": checked, disabled: disabled, onClick: () => onChange(!checked), className: "-my-2 -ml-4 py-2 pl-4 disabled:opacity-50", children: children }), _jsx("button", { type: "button", "aria-label": removeLabel ?? 'Remove', disabled: disabled, onClick: onRemove, className: "-mr-1 inline-flex shrink-0 opacity-70 hover:opacity-100 disabled:opacity-50", children: _jsx("span", { "aria-hidden": true, children: "\u2715" }) })] }));
}
//# sourceMappingURL=toggle-chip.js.map